module.exports = __webpack_public_path__ + "static/copper_dragon_wyrmling-93d7df86d80796e43f7c7077fd3dd4d0.jpg";